import { IExpressionEvaluator } from "../../../Models/IExpressionEvaluator";
import { MaybePromise } from "../../../Models/MaybePromise";
import { IExpressionEvaluatorContext } from "../../../Models/IExpressionEvaluatorContext";
import { StringConcatExpression } from "../../../Models/Strings/StringConcatExpression";

export class StringConcatExpressionEvaluator implements IExpressionEvaluator<StringConcatExpression> {
  get type(): string {
    return "StringConcat";
  }

  private concatStrings(values: any[]): string {
    return values.map((value) => String(value)).join("");
  }

  evaluate(expression: StringConcatExpression, context: IExpressionEvaluatorContext): MaybePromise {
    const results: any[] = [];
    let hasPromise = false;

    for (const valueExpr of expression.Values) {
      const value = context.Evaluator.evaluate(valueExpr, context);
      results.push(value);
      if (value instanceof Promise) {
        hasPromise = true;
      }
    }

    // If any promise exists, wait for all and then concat
    if (hasPromise) {
      return Promise.all(results).then((values) => this.concatStrings(values));
    }

    // All sync, concat immediately
    return this.concatStrings(results);
  }
}
